import { awsImageRootUrl } from "lib/constants";

export const parseImageUrl = (image: string | undefined) => {
  // Sometimes its hard to know if an image will be a full url or just the uuid.
  // This function will return the full url if it is not already a full url.
  // or it will prefix the uuid with the awsImageRootUrl if needed.
  // This will be deprecated once we have more clarity around this convention
  const cleaned = image?.replace('/images/', '');
  if (!cleaned) return undefined;
  if (cleaned.startsWith("http")) return cleaned;
  return `${awsImageRootUrl}/${cleaned}`;
};
